import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useCookiesStore } from '@stores/cookies.store';

export const useGuestDetailsProfile = defineStore('guestActiveProfile', () => {
  const guestActiveProfile = ref();

  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith('active_profile='));
  if (cookieValue) {
    guestActiveProfile.value = JSON.parse(cookieValue.split('=')[1]);
  }

  const saveActiveProfile = (userData) => {
    const cookiesStore = useCookiesStore();
    cookiesStore.setCookie('active_profile', userData);
    guestActiveProfile.value = userData;
  };

  return {
    guestActiveProfile,
    saveActiveProfile,
  };
});
